export default __webpack_public_path__ + "static/media/34.388abe1a.jpg";